import { useState } from 'react';
import { Row, Col, Card, Button, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import BlogList from './BlogList';
import './blog.css';

const BlogAdmin = () => {
  const [showAddBlog, setShowAddBlog] = useState(false);

  return (
    <Container fluid className="p-0">
      <Row>
        <Col>
          <Card className="blog-admin-card">
            <Card.Header className="d-flex justify-content-between align-items-center gap-3">
              <h5 className="mb-0 font-weight-bold">Manage Blogs</h5>
              <Button
                variant="primary"
                className="d-flex align-items-center"
                onClick={() => setShowAddBlog(true)}
              >
                <FontAwesomeIcon icon={faPlus} size="lg" className="me-1" />
                <span>Add New Blog</span>
              </Button>
            </Card.Header>
            <Card.Body>
              <BlogList
                showAddBlog={showAddBlog}
                setShowAddBlog={setShowAddBlog}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BlogAdmin;
